// Importing necessary modules and dependencies
import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import {
    Global
} from '../common/global';
import {
    Sky
} from 'three/addons/objects/Sky.js';
import {
    isMobile
} from 'mobile-device-detect';
import gsap from 'gsap';


// Definition of the GameScene class
export default class Countdown {
    // Constructor takes a scene and camera as parameters
    constructor(scene, camera) {
        this.scene = scene;
        this.camera = camera;
    }

    // Initialization method for setting up event listeners and initial state
    init() {
        // Getting the event dispatcher instance
        this.events = EventDispatcher.getObj();
        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));

        this.addCountdown();
       
    }
    onEvents(data){
       
            
    }
    addCountdown(){
        this.newTick= false;
        this.tickCnt= 4;
        this.countdownTI=setInterval(this.updateCounter.bind(this),1000)
        
        document.querySelector(`.start_sec`).classList.add("active");
    }
    updateCounter(data) {
        this.tickCnt--;

        for(let i=1;i<=3;i++){
            document.querySelector(`.start_sec .counter .start-${i}`).classList.remove('active')
        }
        document.querySelector(`.start_sec .counter .start-go`).classList.remove('active')
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': this.tickCnt<=0?'go':'count'
                }
            }
        });
        if(this.tickCnt<=0){
            document.querySelector(`.start_sec .counter .start-go`).classList.add('active')
            // document.querySelector(`.start_sec .counter .start-${this.tickCnt}`).classList.add('active')
            document.querySelector(".start_sec .counter").classList.remove('active')
            setTimeout(()=>{
                document.querySelector(".start_sec .counter").classList.add('active')
            },100)
            setTimeout(()=>{
                document.querySelector(`.start_sec`).classList.remove("active");
                document.querySelector(`.start_sec .counter .start-go`).classList.remove('active')
            },2000)
            clearInterval(this.countdownTI)
            
            this.events.dispatchEvent({
                type: "GAMESCENE_EVENTS",
                message: {
                    "event_type": "start_game",
                    data: {}
                }
            });
        }else{
            // document.querySelector(`.start_sec .counter`).style.scale=0;
            document.querySelector(`.start_sec .counter .start-${this.tickCnt}`).classList.add('active')
            document.querySelector(".start_sec .counter").classList.remove('active')
            setTimeout(()=>{
                document.querySelector(".start_sec .counter").classList.add('active')
            },100)
        }
        // if (this.counterMixer) {
        //     if(this.counterMixer.time.toFixed(1)%1 == 0.5 && this.newTick){
        //         this.newTick= false;
        //         this.tickCnt--;
        //         console.log(this.tickCnt,'this.tickCnt')
        //         if(this.tickCnt == 0){
        //             this.events.dispatchEvent({
        //                 type: "GAMESCENE_EVENTS",
        //                 message: {
        //                     "event_type": "start_game",
        //                     data: {}
        //                 }
        //             });
        //         }
        //         if(this.tickCnt==3){
        //             this.events.dispatchEvent({
        //                 type: "SOUND_EVENTS",
        //                 message: {
        //                     "event_type": "play_sound",
        //                     data: {
        //                         'sndKey': 'counter'
        //                     }
        //                 }
        //             });
        //         }
        //     }
        //     if(this.counterMixer.time.toFixed(1)%1 == 0.0){
        //         // this.newTick= true;
        //         // if(this.tickCnt == 0){
        //         //     this.counterAction.stop();
        //         // }
               
        //         // console.log("Tick")
        //     }
        //     // this.counterMixer.update(.0075*Global.delta);
        // }
    }
}